import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Typography from '@material-ui/core/Typography'
import Icon from '@material-ui/core/Icon'

import { Space } from '../atoms'

interface ContractContentProps {
  teacherName: string
  studentName: string
}

const contractMenteeListItems = [
  'contract.menteeLine1',
  'contract.menteeLine2',
  'contract.menteeLine3',
  'contract.menteeLine4',
]

const contractMentorListItems = [
  'contract.mentorLine1',
  'contract.mentorLine2',
  'contract.mentorLine3',
  'contract.mentorLine4',
]

const ContractContent: React.SFC<ContractContentProps> = ({
  teacherName,
  studentName,
}) => {
  return (
    <>
      <Typography gutterBottom align={'justify'}>
        <FormattedMessage id={'contract.coachClause'} values={{ teacher: teacherName }} />
      </Typography>

      <Space vertical={10} />

      <Typography gutterBottom align={'justify'}>
        <FormattedMessage id={'contract.coacheeClause'} values={{ student: studentName }} />
      </Typography>

      <Space vertical={10} />

      <Typography variant={'subheading'} color={'primary'}>
        <FormattedMessage id={'contract.mentorContractSubtitle'} />
      </Typography>

      <List>
        {contractMenteeListItems.map(renderContractListItem)}
      </List>

      <Typography variant={'subheading'} color={'primary'}>
        <FormattedMessage id={'contract.menteeContractSubtitle'} />
      </Typography>

      <List>
        {contractMentorListItems.map(renderContractListItem)}
      </List>


    </>
  )
}

const renderContractListItem = (item, i) => (
  <ListItem style={{ alignItems: 'flex-start' }} key={i}>
    <ListItemIcon>
      <Typography>
        <Icon>check-bold</Icon>
      </Typography>
    </ListItemIcon>
    <Typography align={'justify'}>
      <FormattedMessage id={item} />
    </Typography>
  </ListItem>
)

export default ContractContent



// WEBPACK FOOTER //
// ./src/components/molecules/ContractContent.tsx